<template>
  <div class="page_report">
    <formTop @event2="changeDateType($event)" @fatherMethod="getList($event)" :listData="tableData" :listQuery="listQuery" :activeName='activeName' :pathname="pathnames"></formTop>
    <div class="hello">
      <div class="main-con">
        <div class="crumbs2 flex">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>报表</el-breadcrumb-item>
            <el-breadcrumb-item>运营报表</el-breadcrumb-item>
            <el-breadcrumb-item>运营效能报表</el-breadcrumb-item>
          </el-breadcrumb>
          <el-checkbox-group v-model="checkList" v-if="activeName == 'JBreportKFyear'" style="margin-left: 20px;">
            <el-checkbox label="StrDepName1">一级部门</el-checkbox>
            <el-checkbox label="StrDepName2">二级部门</el-checkbox>
            <el-checkbox label="StrprojectName">项目名称</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="operationalReportsTable">
          <div class="ftabs">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane label="月招聘来源总报表（按项目）" name="JBreportKFpro" :disabled="listLoading">
              </el-tab-pane>
              <el-tab-pane label="年度入离职数据统计表" name="JBreportKFyear" :disabled="listLoading">
              </el-tab-pane>
              <el-tab-pane label="月+周度入离职数据统计表" name="JBreportKF" :disabled="listLoading">
              </el-tab-pane>
              <el-tab-pane label="入离职人员明细统计" name="JBreportKFemp" :disabled="listLoading">
              </el-tab-pane>
              <el-tab-pane label="导出记录" name="expRecond" :disabled="listLoading">
              </el-tab-pane>
            </el-tabs>
          </div>
          <!-- :load="load" -->
          <el-table class="doc_table" :max-height="tableHeight - 320 > 350 ? tableHeight - 320 : 350" :data="tableData" row-key="name" v-loading="listLoading" border element-loading-text="报表生成中..." element-loading-spinner="el-icon-loading" style="width: 100%" stripe :row-class-name="tableRowClassName">
            <template v-for="(item,index) in tableTitle">
              <!-- sortable="custom" -->
              <el-table-column :key="index" align="center" :prop="item.StrColumId" :label="item.StrColumName" fit show-overflow-tooltip :width="item.StrColumName=='项目名称' ? '130px' : item.StrColumName.length>4 ? '101px' : '80px'">
                <template slot-scope="{row}">
                  <span v-if="item.StrColumName == '是否再次入职'" :class="row[item.StrColumId]>0 ? 'greenName cp' : ''" @click="viewDtl(row)">
                    {{ row[item.StrColumId] }}
                  </span>
                  <span v-else>
                    {{ row[item.StrColumId] }}
                  </span>
                </template>
              </el-table-column>
            </template>

          </el-table>
          <div class="block" v-if="totalcount>0">
            <el-pagination v-if="activeName!='JBreportKFemp'" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listQuery.currpage" :page-size="listQuery.perpage" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>

            <el-pagination v-if="activeName=='JBreportKFemp'" @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page.sync="listQuery2.pagination.page" :page-size="listQuery2.pagination.pageSize" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="入职记录" :visible.sync="showDtl" width="1050px">
      <el-table :data="dtlData" border class="doc_table" style="width:100%">
        <el-table-column prop="strObjName" label="项目名称" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="strEmpName" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="strIdCard" label="身份证" min-width="160" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="dtEntryBDate" label="用工之日" min-width="140" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">{{ row.dtEntryBDate ? row.dtEntryBDate.split('T')[0] : '' }}</template>
        </el-table-column>
        <el-table-column prop="strWorkState" label="在/离职状态" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="dtDepartureDate" label="离职日期" min-width="140" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">{{ row.dtDepartureDate ? row.dtDepartureDate.split('T')[0] : '' }}</template>
        </el-table-column>
        <el-table-column prop="dtRealDepartureDate" label="实际离职日期" min-width="140" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">{{ row.dtRealDepartureDate ? row.dtRealDepartureDate.split('T')[0] : '' }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "@/common";
  import moment from 'moment';
  import FormTop from "./components/formSearchTop";
  import checkPermission from '@/utils/permission'; // 权限判断函数
  import {
    parseTime
  } from '@/utils' //格式化时间格式
  import {
    e,
    re
  } from "mathjs";
  export default {
    components: {
      FormTop,
      parseTime
    },
    data() {
      return {
        tableHeight: 0,
        listLoading: false,
        tabids: [],
        totalcount: 0,
        btnLoading: false,
        tableData: [],
        p_grouytype: 0,
        old_grouytype: 0,
        tabName: '/report',
        old_tabName: '/report',
        orderArray: [],
        listQuery: {
          currpage: 1,
          perpage: 10,
          projectid: "",
          projectname: "",
          strpartner2: "",
          strDep2: "",
          strservuserid: "",
          actualtype: "",
          strBusiStat: "",
          PushName: "",
          strorgancode: localStorage.gancode,
          roletype: localStorage.loginRoletype,
          dtDatestart: "",
          dtDateend: "",
          strAchieveowner: ""
        },
        listQuery2: {},
        activeName: 'JBreportKFpro',
        oldactiveName: 'JBreportKFpro',
        busTypeList: [], //业务类别列表
        sumTypeList: ['区域汇总', '服务中心汇总', '服务部门汇总', '客服汇总', '合伙人汇总', '业绩归属人汇总', '项目汇总', '业务类型汇总'],
        checkList: ['StrprojectName'],
        tableTitle: [], //表头
        msgtotal: [], //总计数据
        // 按钮权限参数
        butQuery: {
          path: '/report',
          powerEnName: 'reportForms'
        },
        permissionLists: [],
        pathnames: '',
        dtlData: [],
        showDtl: false,
      }
    },
    created() {
      this.calHeight();
      // this.getButtonPower();
      this.getTreestr();
      if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
        this.activeName = this.$route.query.activeName;
        let data = {
          name: this.$route.query.activeName
        }
        this.handleClick(data)
      } else {
        this.getTableTitle();
      }
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
              if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
                this.activeName = this.$route.query.activeName;
                let data = {
                  name: this.$route.query.activeName
                }
                this.handleClick(data)
              } else {
                if (this.checkPermission(['report_tab_customer'], this.permissionLists)) {
                  this.activeName = 'ProfitListRecrEfficiency'
                } else if ((!this.checkPermission(['report_tab_customer'], this.permissionLists)) && (this.checkPermission(['report_tab_recruit'], this.permissionLists))) {
                  this.activeName = 'ProfitListRecrChannel'
                }
                this.getTableTitle();
              }
              // 判断是否有导出权限
              if (this.checkPermission(['report_export'], this.permissionLists)) {
                this.pathnames = 'report'
              } else {
                this.pathnames = 'noreport'
              }
            } else {
              this.permissionLists = []
              this.activeName = ''
            }
          } else {
            this.permissionLists = []
            this.activeName = ''
          }
        })
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        console.log('height', this.tableHeight)
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      handleClick(tab) {
        if (tab.name == 'expRecond') {
          this.$router.push({
            path: '/effExportList'
          })
        } else if (this.oldactiveName == tab.name) {
          return
        } else if (tab.name == 'JBreportKFemp') {
          this.listQuery.start = moment().subtract(7, 'days').format("YYYY-MM-DD");
          this.listQuery.end = moment().format("YYYY-MM-DD");
          this.listQuery2 = {
            "userid": Cookies.get("userid-b"),
            "start": moment().subtract(7, 'days').format("YYYY-MM-DD"),
            "end": moment().format("YYYY-MM-DD"),
            "projectid": this.listQuery.projectid ? this.listQuery.projectid : 0,
            "strDep2": this.listQuery.strDep2,
            "strBusiStat": this.listQuery.strBusiStat,
            "strservuserid": this.listQuery.strservuserid,
            "strpartner2": this.listQuery.strpartner2,
            "strAchieveowner": this.listQuery.strAchieveowner,
            "actualtype": this.listQuery.actualtype,
            "pushName": [],
            "strWorkState": '',
            "pagination": {
              "page": 1,
              "pageSize": 10,
              "orders": []
            }
          }
          this.getTableData();
          this.oldactiveName = tab.name;
        } else if (tab.name == 'JBreportKFyear') { //年度
          const currentYear = moment().year(); // 当前年份
          const currentMonth = moment().month() + 1; // 当前月份 (1-12)
          // 生成 YYYY-MM 格式的月份数组
          const monthsArray = Array.from({
            length: currentMonth
          }, (_, i) => {
            const month = i + 1;
            return `${currentYear}-${month < 10 ? '0' + month : month}`;
          });
          this.listQuery = {
            currpage: 1,
            perpage: this.listQuery.perpage,
            projectid: this.listQuery.projectid,
            projectname: this.listQuery.projectname,
            start: monthsArray[0],
            end: monthsArray[monthsArray.length - 1],
            strMonths: monthsArray.join(','),
            cloums: this.checkList.toString(),
            strorgancode: this.listQuery.strorgancode,
            roletype: this.listQuery.roletype,
          }
          this.getTableTitle();
          this.oldactiveName = tab.name;
        } else {
          if (this.oldactiveName == 'JBreportKFyear') {
            this.clear();
          }
          this.getTableTitle();
          this.oldactiveName = tab.name;
        }
      },
      clear() {
        this.listQuery = this.$options.data.call(this).listQuery;
        this.listQuery.currpage = 1;
        let endDate = moment().format("YYYY-MM-DD");
        let nowdate = moment().subtract(7, 'days').format("YYYY-MM-DD"); // 7天前
        this.listQuery.dtDatestart = nowdate;
        this.listQuery.dtDateend = endDate;
      },
      handleSizeChange(val) {
        this.listQuery.currpage = 1;
        this.listQuery.perpage = val;
        this.getTableData();
      },
      handleCurrentChange(val) {
        this.listQuery.currpage = val
        this.getTableData()
      },
      handleSizeChange2(val) {
        this.listQuery2.pagination.page = 1;
        this.listQuery2.pagination.pageSize = val;
        this.getTableData();
      },
      handleCurrentChange2(val) {
        this.listQuery2.pagination.page = val
        this.getTableData()
      },
      //获取业务类型
      getTreestr() {
        let data = {
          currpage: 1,
          perpage: 100,
          strIsDisable: "",
          keyword: ""
        }
        xz.getTreestr('JB_base_Busitype', data).then(res => {
          if (res.status == "ok") {
            this.busTypeList = res.msg.parent;
          } else {
            this.busTypeList = []
          }
        })
      },
      //获取表头
      getTableTitle() {
        this.listLoading = true;
        if (this.activeName == 'JBreportKFyear') {
          this.listQuery.cloums = this.checkList.toString();
        }
        xz.getReportColumnList(this.activeName, this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableTitle = res.msg;
            this.getTableData();
          } else {
            this.$message.error(res.msg)
            this.tableTitle = [];
          }
        })
      },
      //获取报表信息
      getTableData() {
        this.listLoading = true;
        if (this.activeName != 'JBreportKFemp') {
          const pageMap = {
            'JBreportKFpro': 'getRecrProjects',
            'JBreportKFyear': 'getRepByYear',
            'JBreportKF': 'getReportProjectKF',
            // 'JBreportKFemp': 'getRecrProjectsDetail'
          };
          let pagename = pageMap[this.activeName];
          xz.getReportProjectKF(this.listQuery, pagename).then(res => {
            if (res.status == 'ok') {
              // 如果是年度报表，则添加总计行
              if ((this.activeName === 'JBreportKFpro' || this.activeName === 'JBreportKFyear' || this.activeName === 'JBreportKF') && res.msgtotal) {
                const totalRow = {
                  ...res.msgtotal
                };
                if (this.activeName === 'JBreportKFyear' && this.checkList.length > 0) {
                  let item = this.checkList[0];
                  totalRow[item] = '总计'; // 添加一个标识字段用于显示
                  console.log('111', totalRow[item])
                } else {
                  totalRow.StrprojectName = '总计';
                }
                // totalRow.StrprojectName = '总计'; // 添加一个标识字段用于显示
                res.msg.unshift(totalRow); // 插入到第一行
              }
              this.tableData = res.msg || [];
              this.totalcount = res.count;

            } else {
              this.tableData = [];
              this.totalcount = 0;
            }
            this.listLoading = false;
          });
        } else {
          xz.rcFun(this.listQuery2, 'InterviewOnboarding/GetJoiningLeavingDetailsReport').then(res => {
            if (res.status == 'ok') {
              // 处理 channeldic 数据并匹配 reportTableTitle
              this.processChannelDataWithReportTitle(res.data.data);
              this.totalcount = res.data.totalCount;
            } else {
              this.tableData = []
              this.totalcount = 0
            }
            this.listLoading = false;
          })
        }
      },
      getList(data) {
        this.listQuery = data;
        console.log(data)
        if (this.activeName == 'JBreportKFyear') {
          this.getMonthsBetween();
        } else if (this.activeName == 'JBreportKFemp') {
          this.listQuery.start = moment().subtract(7, 'days').format("YYYY-MM-DD");
          this.listQuery.end = moment().format("YYYY-MM-DD");
          this.listQuery2 = {
            "userid": Cookies.get("userid-b"),
            "start": moment().subtract(7, 'days').format("YYYY-MM-DD"),
            "end": moment().format("YYYY-MM-DD"),
            "projectid": this.listQuery.projectid ? this.listQuery.projectid : 0,
            "strDep2": this.listQuery.strDep2,
            "strBusiStat": this.listQuery.strBusiStat,
            "strservuserid": this.listQuery.strservuserid,
            "strpartner2": this.listQuery.strpartner2,
            "strAchieveowner": this.listQuery.strAchieveowner,
            "actualtype": this.listQuery.actualtype,
            "pushName": [],
            "strWorkState": '',
            "pagination": {
              "page": 1,
              "pageSize": 10,
              "orders": []
            }
          }
          this.getTableData();
        } else {
          this.getTableTitle()
        }
      },
      processChannelDataWithReportTitle(data) {
        // 从 store 中获取 reportTableTitle
        this.tableTitle = this.$store.state.EMP.reportTableTitle;

        // 提取所有渠道相关的列（这些列在 reportTableTitle 中有对应的 StrColumId）
        const channelColumns = this.tableTitle.filter(col =>
          // 过滤出那些在示例数据中可能出现在 channeldic 中的列
          ['社招推荐人', '网招中心', '公司渠道', '校招部', '业务项目部', '招聘部', '客服部',
            '宁波网招', '小杰门店', '企业转移', '员工内荐', '供应商', '其他情况'
          ].includes(col.StrColumName)
        );

        // 处理数据，将 channeldic 展开为独立字段
        const processedData = data.map(item => {
          const newItem = {
            ...item
          };

          // 为所有渠道字段初始化默认值为 0
          channelColumns.forEach(col => {
            newItem[col.StrColumId] = 0;
          });

          // 如果存在 channeldic 对象，将其键值对展开为独立字段
          if (item.channeldic && typeof item.channeldic === 'object') {
            Object.keys(item.channeldic).forEach(key => {
              // 使用 reportTableTitle 中定义的 StrColumId 作为字段名
              const columnConfig = this.tableTitle.find(col => col.StrColumName === key);
              if (columnConfig) {
                newItem[columnConfig.StrColumId] = item.channeldic[key];
              } else {
                // 如果 reportTableTitle 中没有定义，则使用原 key 作为字段名
                newItem[key] = item.channeldic[key];
              }
            });
          }

          return newItem;
        });

        // 更新表格数据
        this.tableData = processedData;
      },
      //获取起止时间中间的所有月份列表
      getMonthsBetween() {
        const start = moment(this.listQuery.start); // 起始日期
        const end = moment(this.listQuery.end); // 结束日期
        const monthsArray = [];

        if (!start.isValid() || !end.isValid()) {
          console.error('日期格式不正确');
          return [];
        }

        let current = start.clone();

        while (current.isSameOrBefore(end, 'month')) {
          monthsArray.push(current.format('YYYY-MM'));
          current.add(1, 'month');
        }
        this.listQuery.strMonths = monthsArray.join(',');
        this.getTableTitle();
      },
      tableRowClassName({
        row
      }) {
        if (row.StrDepName1 === '总计') {
          return 'total-row';
        }
        if (row.StrDepName2 === '总计') {
          return 'total-row';
        }
        if (row.StrprojectName === '总计') {
          return 'total-row';
        }
        return '';
      },
      viewDtl(row) {
        // if (row.empDetails.length > 0) {
        //   this.dtlData = row.empDetails;
        //   this.showDtl = true;
        // }
        let str = `InterviewOnboarding/GetJoiningLeavingDetailsE?strIdCard=${row.strIdCard}&strObjName=${row.strprojectName}`
        xz.rcGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.dtlData = res.data;
            this.showDtl = true;
          } else {
            this.dtlData = [];
            this.showDtl = true;
          }
        })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    width: 100%;
  }

  .refeshTime {
    font-size: 14px;
    color: #909399;
    margin-right: 30px;
  }

  .checkedgroup {
    margin-bottom: 10px;
    display: flex;
    /* flex-flow: wrap; */
  }

  .checkboxTitle {
    white-space: nowrap;
    font-size: 14px;
  }

  .total-header {
    background-color: #f5f7fa;
    font-weight: bold;
  }

  .greenName {
    font-weight: 600;
    font-size: 14px;
  }
</style>
<style>
  .page_date_top .el-date-editor--daterange .el-input__icon {
    line-height: 26px;
  }

  .page_report .ftabs .el-tabs__header {
    margin: 0;
  }

  .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .el-checkbox__label {
    padding-left: 3px;
  }

  .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }

  .checkedgroup2 .el-radio {
    /* margin-bottom: 5px; */
    margin-right: 10px;
    height: 23px;
    line-height: 23px;
  }

  .operationalReportsTable .el-table th.el-table__cell>.cell {
    padding-right: 0 !important;
  }

  .operationalReportsTable .el-table .sort-caret.descending {
    border-top-color: #19bd92
  }

  .operationalReportsTable .el-table .sort-caret.ascending {
    border-bottom-color: #19bd92
  }

  .operationalReportsTable .el-table .ascending .sort-caret.ascending {
    border-bottom-color: red;
  }

  .operationalReportsTable .el-table .descending .sort-caret.descending {
    border-top-color: red;
  }

  .page_report .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none;
  }

  .page_report .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_report .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_report .doc_table .total-row {
    background-color: rgb(255, 199, 206);
    font-weight: bold;
  }
</style>